export default function techinicalteams(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                techinicalteam: action.techinicalteam,
            }
        default:
            return state;
    }
}
